<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">培训记录查询</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item style="width: 130px">
              <el-input
                v-model="formInline.regName"
                placeholder="姓名"
                clearable
                @keyup.enter.native="onSearch"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item style="width: 100px">
              <el-select v-model="formInline.sex" placeholder="性别" clearable>
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item style="width: 200px">
              <el-input
                v-model="formInline.regIdcard"
                placeholder="证件号码"
                clearable
                @keyup.enter.native="onSearch"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="formInline.phone" placeholder="手机号码" clearable></el-input>
            </el-form-item>-->
            <el-form-item>
              <el-select
                v-model="formInline.postId"
                placeholder="专业"
                clearable
                @change="onSearch"
              >
                <el-option
                  v-for="(item, i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="formInline.affiliatedEnterprise"
                placeholder="所属企业"
                clearable
                @keyup.enter.native="onSearch"
              ></el-input>
            </el-form-item>
            <el-form-item prop="batchId">
              <el-select
                v-model="formInline.batchId"
                placeholder="报名批次"
                clearable
                @change="onSearch"
              >
                <el-option
                  v-for="(item, i) in batchList"
                  :key="i"
                  :label="item.batchName"
                  :value="item.batchId"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
              <el-select v-model="formInline.batch" placeholder="报名批次" clearable>
                <el-option label="第一批" value="shanghai"></el-option>
                <el-option label="第二批" value="beijing"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item>
              <el-select
                v-model="formInline.dataType"
                placeholder="报名类型"
                clearable
                @change="onSearch"
              >
                <el-option label="继教" value="1"></el-option>
                <el-option label="换证" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="annualType">
              <el-select
                v-model="formInline.annualType"
                placeholder="请选择继教年度"
                clearable
                @change="onSearch"
              >
                <el-option
                  v-for="item in followingTeaching"
                  :key="item.annualTypeId"
                  :label="item.annualTypeName"
                  :value="item.annualTypeId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 100px">
              <el-select
                v-model="formInline.overStatus"
                placeholder="学习状态"
                clearable
                @change="studyChange"
              >
                <el-option label="待学习" value="0"></el-option>
                <el-option label="已学完" value="1"></el-option>
                <el-option label="学习中" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="width: 100px">
              <el-select
                v-model="formInline.reportingStatus"
                placeholder="上报状态"
                clearable
                @change="onSearch"
              >
                <el-option label="已上报" value="0"></el-option>
                <el-option label="未上报" value="1"></el-option>
              </el-select>
            </el-form-item>

             <el-form-item style="width: 100px">
              <el-select
                v-model="formInline.approvalStatus"
                placeholder="审核状态"
                clearable
                @change="onSearch"
              >
                <el-option label="通过" value="0"></el-option>
                <el-option label="不通过" value="1"></el-option>
                <el-option label="待审核" value="2"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item style="width: 120px">
              <el-select
                v-model="formInline.examResults"
                placeholder="测试结果"
                clearable
                @change="testChange"
              >
                <el-option label="合格" value="0"></el-option>
                <el-option label="不合格" value="1"></el-option>
                <el-option label="未测试" value="2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-date-picker
              class="picker"
              style="margin-right: 10px"
              v-model="applyValue"
              type="daterange"
              :picker-options="pickerOptions"
              unlink-panels
              range-separator="至"
              start-placeholder="激活时间起"
              end-placeholder="激活时间止"
              size="small"
              align="right"
              value-format="yyyy-MM-dd"
              @change="onSearch"
            ></el-date-picker>
            <!-- <el-form-item style="width:200px"> -->
            <el-button type="primary" size="small" @click="onSearch"
              >查询</el-button
            >
            <el-button
              class="btns"
              style="margin-bottom: 20px"
              type="success"
              size="small"
              @click="exportTrain"
              >批量导出培训信息</el-button
            >
          </el-form>
          <el-table
            :data="tableData"
            border
            max-height="650"
            ref="fileTable"
            :cell-style="cellStyle"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            highlight-current-row
            :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
          >
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="regName"
              label="姓名"
              min-width="80"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              :formatter="sexFormat"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="idCard"
              label="身份证号"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="courseName"
              label="课程名称"
              min-width="150"
            ></el-table-column>
            <!-- <el-table-column prop="postId" label="专业" :formatter="specialFormat" min-width="120"></el-table-column> -->
            <el-table-column
              prop="postName"
              label="专业"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="affiliatedEnterprise"
              label="所属企业"
              min-width="80"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="batchName"
              label="报名批次"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="继教年度"
              prop="annualName"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="继续教育年份"
              min-width="120"
              prop="learnYear"
            ></el-table-column>
            <el-table-column
              prop="dataType"
              label="报名类型"
              :formatter="dataTypeFormatter"
            ></el-table-column>
            <el-table-column
              prop="reportingStatus"
              label="上报状态"
              :formatter="reportingFormatter"
            ></el-table-column>
            <el-table-column
              prop="approvalStatus"
              label="审核状态"
              :formatter="approvalFormatter"
            ></el-table-column>
            
            <el-table-column
              prop="courseTotalHours"
              label="总学时"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="finishedHourse"
              label="已完成学时"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="overStatus"
              label="学习状态"
              :formatter="studyFormat"
              width="100"
            ></el-table-column>
            <!-- <el-table-column
              prop="examResults"
              label="测试结果"
              :formatter="resultFormat"
              width="120"
            ></el-table-column> -->
            <!-- <el-table-column prop="createDate" label="测试结果时间" width="120"></el-table-column> -->
            <el-table-column
              prop="regDate"
              label="激活时间"
              width="170"
            ></el-table-column>
            <el-table-column
              prop="regCertificateDate"
              label="发证时间"
              width="160"
            ></el-table-column>
            <el-table-column label="操作" fixed="right" width="160">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="primary"
                  size="mini"
                  >查看学习照片</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handlePageChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 查看学习照片 -->
      <el-dialog
        title="查看学习照片"
        :visible.sync="detailDialog"
        width="80%"
        center
        top="5vh"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        @close="clearCache"
        @open="(loading = true), (editIndex = -1)"
      >
        <div class="imgs">
          <div class="case">
            <span class="tag">本人登记照：</span>
            <img :src="imgInfo.empHeadportrait" alt />
            <div v-if="!imgInfo.empHeadportrait" class="inline not">
              暂无登记照
            </div>
          </div>
          <div class="case">
            <span class="tag">身份证正面照片：</span>
            <img :src="imgInfo.empIdcardFront" alt />
            <div v-if="!imgInfo.empIdcardFront" class="inline not">
              暂无身份证正面照片
            </div>
          </div>
        </div>
        <el-table
          :data="photoInfo"
          border
          max-height="500"
          :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
          :row-class-name="tableRowClassName"
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <!-- <el-table-column prop="courseName" label="课程名称" width="180"></el-table-column> -->
          <!-- <el-table-column prop="ccName" label="章节名称" min-width="120"></el-table-column> -->
          <el-table-column
            tree-props="{children: 'children'}"
            label="章节名称"
            min-width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sectionName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="courseOver"
            :formatter="finishedFormat"
            label="完成状态"
            width="120"
          ></el-table-column>
          <el-table-column label="开始时间" width="220">
            <template slot-scope="scope">
              <span>
                <span :class="{ 'text-warning': scope.row.textWarning }">
                  {{ scope.row.courseStudyStart }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="220">
            <template slot-scope="scope">
              <span>
                <span :class="{ 'text-warning': scope.row.textWarning }">
                  {{ scope.row.courseStudyEnd }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="课程观看时长" width="220">
            <template slot-scope="scope">
              <span>{{ scope.row.courseTime }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="createdate"
            :formatter="createTime"
            label="拍照上传时间"
            width="120"
            show-overflow-tooltip
          ></el-table-column>-->
          <!-- 
          <el-table-column prop="empIdcardFront" label="身份证正面照片" min-width="100">
            <template slot-scope="scope">
              <img class="small" :src="scope.row.empIdcardFront" alt />
            </template>
          </el-table-column>-->
          <el-table-column label="实时拍摄照片" width="240">
            <template slot-scope="scope" v-if="scope.row.photoList.length != 0">
              <el-image
                v-for="(item, index) in scope.row.photoList"
                :key="index"
                :src="item"
                style="width: 60px; height: 60px; margin: 0 5px"
                :preview-src-list="getImgList(scope.row.photoList, index)"
              />
              <!-- <img class="small" :src="scope.row.photoUrl" alt /> -->
            </template>
          </el-table-column>
          <!-- <el-table-column label="审核状态" :formatter="invalidFormate" width="120"> -->
          <el-table-column
            label="审核状态"
            tree-props="{children: 'children'}"
            width="120"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" :disabled="scope.row.invalid !== 1">
                <div slot="content">{{ scope.row.invalidComment }}</div>
                <el-button
                  type="text"
                  v-if="scope.row.state == '通过'"
                  style="color: #67c23a"
                  >{{ scope.row.state }}</el-button
                >
                <el-button
                  type="text"
                  v-else-if="scope.row.state == '不通过'"
                  style="color: #f56c6c"
                  >{{ scope.row.state }}</el-button
                >
                <el-button type="text" v-else style="color: #409eff">{{
                  scope.row.state
                }}</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 审核弹框 -->
      <el-dialog
        class="auditForm"
        title="审核状态"
        :visible.sync="auditDialog"
        width="40%"
        center
        @close="resetForm('form')"
      >
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="不合格原因：" prop="comment">
            <el-input
              type="textarea"
              v-model="form.comment"
              @input="change($event)"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="nopass" size="small">审核未通过</el-button>
          <el-button
            type="primary"
            @click="auditDialog = false"
            size="small"
            plain
            >取消</el-button
          >
        </span>
      </el-dialog>

      <!-- 查看照片 -->
      <el-dialog
        width="30%"
        title="查看照片"
        :visible.sync="photoShowDialog"
        :before-close="handleClose"
        append-to-body
      >
        <ul v-if="singlePhotoDataList.length > 0" class="photoShowBox">
          <li v-for="(item, index) in singlePhotoDataList" :key="index">
            <img :src="item.photoUrl" />
            <i class="el-icon-circle-close" @click="deleteItem(item)"></i>
          </li>
        </ul>
        <div v-if="singlePhotoDataList.length < 3" class="uploadFileBox">
          <div ref="singlePhotoList">
            <el-upload
              class="avatar-uploader"
              accept=".jpg, .jpeg, .jif, .png"
              :action="uploadUrl"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleAvatarSuccess"
              v-model="singlePhotoList"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
import http from "../api/module";
import pagination from "../components/pagination";
import { courseURL, bizURL } from "../api/baseUrl";
export default {
  name: "queryRecord",
  components: {
    HeaderCom,
    pagination,
  },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      specialList: [],
      uploadUrl: bizURL + "/employee/uploadImage",
      uploadFileLoad:
        courseURL +
        "/videoPlay/uploadZip?tokenId=" +
        sessionStorage.getItem("token"),
      batchList: JSON.parse(sessionStorage.getItem("batchList")),
      entpId: sessionStorage.getItem("entpId"),
      formInline: {},
      detailDialog: false,
      tableData: [],
      multipleSelection: [], // 表格被选中的内容
      photoDialog: false,
      auditDialog: false,
      photoInfo: [],
      isDisabled: false,
      imgInfo: {},
      applyValue: [],
      form: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      followingTeaching: [],
      singlePhoto: sessionStorage.getItem("singlePhoto"), //单个照片
      batchPhoto: sessionStorage.getItem("batchPhoto"), //批量上传
      photoShowDialog: false,
      singlePhotoDataList: [],
      singlePhotoList: "", //上传图片
    };
  },

  mounted() {
    this.getPostList();
    this.getData();
    this.getSelectAnnualType();
  },
  methods: {
    //管理照片点击事件
    handleManagementPhoto(row) {
      this.regId = row.regId;
      this.courseId = row.courseId;
      this.empId = row.empId;
      this.ccId = row.ccId;
      this.entpId = row.entpId;
      http
        .getUserSaveStudyPhoto({
          regId: this.regId,
          ccId: this.ccId,
        })
        .then((data) => {
          if (data.data.success == true) {
            this.singlePhotoDataList = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        });
      this.photoShowDialog = true;
    },
    // 单个删除照片
    deleteItem(item) {
      this.$confirm("是否确认该照片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          http
            .delPhoto({
              photoId: item.id,
            })
            .then((data) => {
              if (data.data.success == true) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.handleManagementPhoto(item);
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    beforeUpload(file) {
      const isLt200k = file.size / 1024 < 200;
      if (!isLt200k) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片大小不能超过 200k！",
        });
      }
      return isLt200k;
    },
    // 获取上传图片路径
    handleAvatarSuccess(res, file, fileList) {
      if ((res.code = 200)) {
        this.singlePhotoList = res.data;
        http
          .userSaveStudyPhoto({
            courseId: this.courseId,
            regId: this.regId,
            ccId: this.ccId,
            photoUrl: this.singlePhotoList,
            entpId: this.entpId,
            empId: this.empId,
          })
          .then((data) => {
            if (data.data.success == true) {
              this.$message.success({
                duration: 1000,
                message: data.data.message,
              });
              let params = {
                regId: this.regId,
                ccId: this.ccId,
              };
              this.handleManagementPhoto(params);
            } else {
              this.$message.error({
                duration: 1000,
                message: data.data.message,
              });
            }
          });
      }
    },

    // 批量上传照片
    beforeUploadFileZip(file) {
      this.loading = true;
      const isLt80k = file.size / 1024 / 1024 < 400;
      if (!isLt80k) {
        this.$message.warning({
          duration: 1000,
          message: "上传文件大小不能超过 400MB！",
        });
      }
      return isLt80k;
    },
    // 批量上传照片成功回调
    handleBatchUploadSuccess(res, file, fileList) {
      this.loading = true;
      if (res.success == true) {
        this.loading = false;
        this.$message.success({
          duration: 3000,
          message: "上传成功",
        });
      } else {
        this.$message.error({
          duration: 3000,
          message: res.message,
        });
        this.loading = false;
      }
    },
    //弹窗关闭清空图片缓存
    clearCache() {
      this.imgInfo = {};
      this.photoInfo = [];
    },
    //表格数据转化
    dataTypeFormatter(row) {
      return row.dataType == 0 ? "换证" : "继教";
    },
    //表格数据转化-上报状态
    reportingFormatter(row) {
      return row.reportingStatus == 0 ? "已上报" : "未上报";
    },
      //表格数据转化-审核状态
    approvalFormatter(row) {
      return row.approvalStatus == 0 ? "通过" :row.approvalStatus == 1? "不通过":'待审核';
    }, 
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    change(e) {
      // input 视图更新
      this.$forceUpdate();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 13) {
        return row.examResults == "0" ? "color:#67C23A" : "color:#F56C6C";
      } else {
        return "";
      }
    },
    sexFormat(row) {
      var sex = row.sex;
      return sex == "0" ? "男" : "女";
    },
    // 学习状态
    studyFormat(row, column) {
      var state = row.overStatus;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    resultFormat(row) {
      var examResults = row.examResults;
      return examResults == "0" ? "合格" : examResults == "1" ? "不合格" : "";
    },
    studyChange(val) {
      this.formInline.studyState = val;
      this.onSearch()
    },
    testChange(val) {
      this.formInline.examResults = val;
      this.onSearch()
    },
    regDateBegin(val) {
      var value = val.split(" ")[0];
      this.formInline.regDateBegin = value;
    },
    regDateEnd(val) {
      var value = val.split(" ")[0];
      this.formInline.regDateEnd = value;
    },
    // 当前页
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    // 每页数
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getData();
    },
    // 获取注册专业
    getPostList() {
      // this.isDisabled = false;
      http
        .getSpecial()
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.specialList = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            duration: 1000,
            message: "服务器错误,请联系管理员!",
          });
        });
    },
    // 当某一行被点击时触发
    rowClick(row, column, event) {
      // console.log(row, "rowClick");
      this.$refs.fileTable.toggleRowSelection(row);
    },
    // 当选择项发生变化时触发
    selectioChange(selection) {
      // console.log(selection, "selection");
      this.multipleSelection = selection;
      this.btrIds = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var item = this.multipleSelection[i];
        var btrId = item.btrId;
        this.btrIds.push(btrId);
      }
    },
    // 导出培训信息
    exportTrain() {
      var param = "";
      var url = `${courseURL}/trainingRecord/getEntpTrainingRecord?tokenId=${sessionStorage.getItem(
        "token"
      )}&entpId=${sessionStorage.getItem("entpId")}&export=1&`;
      var data = {
        regName: this.formInline.regName,
        regSex: this.formInline.sex,
        regIdcard: this.formInline.regIdcard,
        postId: this.formInline.postId,
        affiliatedEnterprise: this.formInline.affiliatedEnterprise,
        regBatch: this.formInline.batchId,
        overStatus: this.formInline.overStatus,
        dataType: this.formInline.dataType,
        annualType: this.formInline.annualType,
        examResults: this.formInline.examResults,
        reportingStatus: this.formInline.reportingStatus ===''? null:this.formInline.reportingStatus,
        approvalStatus: this.formInline.approvalStatus ===''? null:this.formInline.approvalStatus,
        suspensionType : 0,
        regDateBegin: this.applyValue ? this.applyValue[0] : null,
        regDateEnd: this.applyValue ? this.applyValue[1] : null,
      };
      Object.keys(data).map((key) => {
        if (data[key] != undefined && data[key] != null) {
          url += key + "=" + data[key] + "&";
        }
      });
      // console.log(url); // 输出结果  hfcrm/cm/api/user?download=1a=11&b=22&c=33
      window.location.href = url;

      // var param = "";
      // var url = `${courseURL}/trainingRecord/getEntpTrainingRecord?tokenId=${sessionStorage.getItem(
      //   "token"
      // )}&entpId=${sessionStorage.getItem("entpId")}&export=1`;
      // for (var i in this.formInline) {
      //   param = param + i + "=" + this.formInline[i] + "&";
      // }
      // param = param.slice(0, param.length - 1);

      // if (param == "") {
      //   window.location.href = url;
      // } else {
      //   window.location.href = url + "&" + param;
      // }
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    getData() {
      http
        .getTrain({
          pageNum: this.currentPage,
          pageSize: this.limit,
          regName: this.formInline.regName,
          regSex: this.formInline.sex,
          regIdcard: this.formInline.regIdcard,
          postId: this.formInline.postId,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          regBatch: this.formInline.batchId,
          overStatus: this.formInline.overStatus,
          dataType: this.formInline.dataType,
          annualType: this.formInline.annualType,
          examResults: this.formInline.examResults,
          reportingStatus: this.formInline.reportingStatus ===''? null:this.formInline.reportingStatus,
          approvalStatus: this.formInline.approvalStatus ===''? null:this.formInline.approvalStatus,
          suspensionType : 0,
          regDateBegin: this.applyValue ? this.applyValue[0] : null,
          regDateEnd: this.applyValue ? this.applyValue[1] : null,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！",
          });
        });
    },
    // 专业
    specialFormat(row, column, cellValue, index) {
      var cellValue = cellValue;
      for (var i = 0; i < this.specialList.length; i++) {
        var item = this.specialList[i];
        var postId = item.postId.toString();
        if (cellValue == postId) {
          return item.postName;
        }
      }
    },
    finishedFormat(row, column) {
      var state = row.courseOver;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    /* finishTime(row, column) {
      var state = row.courseOver;
      var time = row.sysUpdatetime;
      // return state == "0" || state == "" ? "" : time;
      return state == "1" ? time : '';
    }, */
    createTime(row, column) {
      var state = row.courseOver;
      var time = row.createdate;
      return state == "0" || state == "" ? "" : time;
    },
    invalidFormate(row, column) {
      var state = row.invalid;
      return state === true ? "不合格" : state === false ? "合格" : "";
    },
    handleClick(row) {
      this.detailDialog = true;
      this.regId = row.regId;
      this.courseId = row.courseId;
      this.empId = row.empId;
      // this.getEmployeeInformation();
      this.employeeDetail();
      this.getPhotoList();
    },
    getEmployeeInformation() {
      http
        .getEmployeeInformation()
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            console.log(data);
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },
    // 根据用户id获取用户信息
    employeeDetail() {
      http
        .employeeDetail({
          empId: this.empId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.imgInfo = data.data.data;
            this.loading = false;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },
    getPhotoList() {
      http
        .getPhoto({
          regId: this.regId,
          courseId: this.courseId,
          empId: this.empId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            let newList = [];
            let upItem = null;
            let oldList = data.data.data;
            for (const item of oldList) {
              var invalid = item.invalid;
              item.state =
                invalid === 0 ? "通过" : invalid === 1 ? "不通过" : "待审核";
              var cateName = item.cateName;
              var ccName = item.ccName;
              var photoList = item.photoList;
              item.sectionName = cateName + "——" + ccName;
              if (photoList.length) {
                for (let j = 0; j < photoList.length; j++) {
                  photoList[j] = photoList[j].photoUrl;
                }
              }
              // ================== begin 判断开始时间和完成时间相差是否小于35分钟 及 上一轮的结束时间小于当前轮的开始时间 begin ==================
              var date1 = new Date(item.courseStudyStart).getTime();
              var date2 = new Date(item.courseStudyEnd).getTime();
              // 上一轮的结束时间小于当前轮的开始时间
              if (upItem && upItem > date1) {
                item.textWarning = true;
              }
              var diff = Math.abs(date1 - date2);
              var minutes = Math.floor(diff / 1000 / 60);
              item.minutes = minutes < 35 ? true : false;
              console.info('------------------item.minutes------------------',item.minutes)
              newList.push(item);
              upItem = date2;
              // ================== end 判断开始时间和完成时间相差是否小于35分钟 及 上一轮的结束时间小于当前轮的开始时间 end ==================
            }
            this.photoInfo = newList;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.minutes) {
        return "warning-row";
      }
    },

    //查看图片
    getImgList(photoList, index) {
      let arr = [];
      if (photoList.length == 1) {
        arr.push(photoList[0]);
      } else if (photoList.length == 0) {
        return arr;
      } else {
        for (let i = 0; i < photoList.length; i++) {
          arr.push(photoList[i + index]);
          if (i + index >= photoList.length - 1) {
            index = 0 - (i + 1);
          }
        }
      }
      return arr;
    },

    // 审核状态
    auditClick(row) {
      // console.log(row, "auditClick");
      this.auditDialog = true;
      // this.studyIds = [];
      this.empStudyId = row.empStudyId;
      // if (!empStudyId) {
      // this.studyIds.push(empStudyId);
      // }
      // console.log(this.studyIds, "ids");
    },
    // 审核未通过
    nopass() {
      // console.log(this.studyIds, "this.studyIds");
      var comment = this.form.comment;
      if (comment) {
        http
          .setEmpStudyListInvalid({
            comment: comment,
            // 'empStudyIdList[0]': this.studyIds[0]
            "empStudyIdList[0]": this.empStudyId,
          })
          .then((data) => {
            if (data.data.code == "200" || data.data.success) {
              this.auditDialog = false;
              this.getPhotoList();
            } else {
              this.$message.error({
                duration: 1000,
                message: data.data.message,
              });
            }
          })
          .catch((error) => {});
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请输入不合格原因!",
        });
        return false;
      }
    },
    // 批量打印培训证明
    batchPrint() {
      this.$confirm("确认打印培训证明吗?", "批量打印培训证明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "打印成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印",
          });
        });
    },

    handleClose() {
      this.photoShowDialog = false;
      this.singlePhotoDataList = [];
    },
    // 获取继续教育年度数据
    getSelectAnnualType() {
      http.selectAnnualType().then((res) => {
        if (res.data.code) {
          this.followingTeaching = res.data.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  font-size: 16px;
}
.cont {
  margin-top: 20px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.head {
  line-height: 30px;
  font-size: 18px;
  color: #000;
  h3 {
    font-weight: normal;
  }
}
.small {
  display: inline-block;
  height: 100px;
  width: auto;
}
.imgs {
  width: 100%;
  padding: 0 100px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
  .tag {
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
  }
  img {
    max-height: 140px;
    width: auto;
  }
  .not {
    margin-left: 10px;
    color: rgb(136, 133, 133);
  }
}
.auditForm /deep/.el-dialog__body {
  padding-bottom: 0;
}
/deep/.el-textarea__inner {
  min-height: 80px !important;
}
.photoShowBox {
  display: inline-block;
  overflow: hidden;
  li {
    display: inline-block;
    float: left;
    margin: 10px;
    position: relative;
    img {
      width: 152px;
      height: 152px;
    }
    i {
      position: absolute;
      right: -10px;
      top: -10px;
      font-size: 24px;
      color: #ce1013;
      cursor: pointer;
      z-index: 10;
    }
  }
}
.uploadFileBox {
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
  margin-left: 10px;
  .avatar-uploader-icon {
    width: 148px !important;
    height: 148px !important;
    line-height: 148px;
  }
}

.uploadFile {
  display: inline-block;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  outline: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  padding: 7px 15px;
  border-radius: 3px;
  margin-left: 10px;
  vertical-align: middle;
}
/deep/.el-table .warning-row {
  background: rgb(236, 176, 176);
}
/deep/.el-table .text-warning {
  color: #5babf7;
}
</style>